import { resolveBasePath } from "@/shared/helpers/basePath";

declare global {
  interface Window {
    __RUNTIME_CONFIG__?: ImportMetaEnv;
  }
}

const ENV = {
  VERSION: import.meta.env.VITE_APP_VERSION,
  API_SERVER: String(import.meta.env.VITE_API_SERVER ?? window.__RUNTIME_CONFIG__?.VITE_API_SERVER ?? "/api"),
  BASE_PATH: resolveBasePath(),
  TERMS_AND_CONDITIONS_URL: import.meta.env.VITE_TERMS_AND_CONDITIONS_URL ?? window.__RUNTIME_CONFIG__?.VITE_TERMS_AND_CONDITIONS_URL,
  PRIVACY_POLICY_URL: import.meta.env.VITE_PRIVACY_POLICY_URL ?? window.__RUNTIME_CONFIG__?.VITE_PRIVACY_POLICY_URL,
  DISCLOSURE_URL: import.meta.env.VITE_DISCLOSURE_URL ?? window.__RUNTIME_CONFIG__?.VITE_DISCLOSURE_URL,
  SUPPORTED_LOCALES: import.meta.env.VITE_SUPPORTED_LOCALES ?? window.__RUNTIME_CONFIG__?.VITE_SUPPORTED_LOCALES,
} as const;

export default ENV;
